export const DECIMAL_OFFSET = 100;
